import Svg, { Circle, Path, Rect } from 'react-native-svg';
import type { MinimalSvgProps } from './index';
import { withDefaultIconProps } from './index';

export const ImagePickerIcon = withDefaultIconProps<MinimalSvgProps & { strokeWidth?: number }>(
  {
    height: 24,
    width: 24,
    // ImagePickerIcon uses strokes which appear heavier at small sizes compared to
    // fill-based icons (e.g. Camera). This scale correction makes it visually
    // balanced when both are given the same size prop.
    scale: 34 / 36,
  },
  ({ color, strokeWidth = 1.3, ...rest }) => (
    <Svg {...rest} fill="none">
      {/* Front card */}
      <Rect
        transform="translate(4.5, 5)"
        width="15"
        height="15"
        rx="2.5"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Sun */}
      <Circle transform="translate(2, -1)" cx="8" cy="10.5" r="1.5" fill={color} />
      {/* Mountains */}
      <Path
        transform="translate(1.5, -1)"
        d="M3 18.5l4-5 2.5 2.5 3-4L18 18.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Svg>
  ),
);
